import { HubSections } from '@/components/hub/HubSections';
import { HubTour } from '@/components/tour/HubTour';

/**
 * Hub — single-viewport layout that never scrolls.
 *
 * Banner → currencies → section buttons → the selected section's screen.
 * Picking a section swaps the panel in place: the Hub IS the screen, it doesn't
 * navigate to one. Which sections exist depends on the active game
 * (see `HubSections`) — "My battles" and "Top decks" are Clash Royale things.
 *
 * The banner itself is NOT here: it is app chrome, rendered once by
 * <AppBanner /> in AppShell so it holds the same spot on every screen. The Hub
 * fills its top slot (the row above the banner) with the currency HUD;
 * the game selector + account identities moved to Settings.
 *
 * What used to live here (League card, cross-game pills, per-game sections for
 * Chess/CoC/Backgammon/Chinese Poker/Riot, the avatar CTA and bottom hero) is
 * gone from the Hub. Each keeps its own route; the Hub stopped being a
 * catalogue of everything and became a few buttons and a screen.
 */
export function Hub() {
  return (
    <div
      // touch-action: none blocks pan/zoom/swipe on the Hub chrome — no
      // rubber-band, no pull-to-refresh. The section panel re-enables its own
      // vertical scroll, and is the only thing here that moves.
      // pt-1 (non pt-3): sotto il banner lo spazio era doppio — il pt di qui si
      // sommava al distacco del banner stesso — e il contenuto sembrava
      // staccato dalla chrome a cui appartiene. L'aria e' stata spostata SOPRA
      // il banner, dove serviva davvero per separarlo dalle valute.
      className="flex h-full flex-col gap-3 overflow-hidden px-4 pb-3 pt-1 [touch-action:none]"
    >
      {/* Above the banner, right-aligned: the currency HUD (tap it to open the
          shop). The QAvatar hangs off the banner's bottom-LEFT corner, so this
          takes the side it doesn't reach. A little margin from the banner comes
          from the banner's own `mt-3`. */}
      {/* Livello e valute non stanno più qui: sono chrome e vivono in
          <AppBanner />, così compaiono su ogni schermata e non solo sulla Hub. */}
      {/* Buttons + the selected section's screen. This is the Hub now. */}
      <HubSections />

      <HubTour />
    </div>
  );
}
